// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"133":"layout","353":"contact","461":"skills","594":"about","962":"home"}[chunkId] + "." + {"133":"3a04ff92","353":"7a0f0f5b","461":"4768b4b1","594":"6a37030d","962":"3c2ecb2f"}[chunkId] + ".css";
};